import { IconLock, IconPeopleFill, IconWorld } from 'components/icons';
import {
  DEFAULT_DESCRIPTION,
  DEFAULT_OG_IMAGE,
  DEFAULT_TITLE,
  MAIN_DOMAIN,
  SITE_MAP,
} from 'globalConstants';
import { POST_MODE } from 'graphql/main/mutations/temp/create-post';
import { isEqual } from 'lodash';
import { GetServerSideProps, NextPage } from 'next';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { Context, Fragment, createContext } from 'react';
import { detectDeviceByUserAgent } from 'utils';

const CommunityPost = dynamic(() => import('components/desktop/temp/community-post'));
const MobileCommunityPost = dynamic(() => import('components/mobile/temp/community-post'));

export const DEFAULT_FEEDS_LIMIT = 20;
export const POST_MODE_OPTIONS = [
  {
    label: 'Công khai',
    value: POST_MODE.public,
    icon: <IconWorld className='h-[18px] w-[18px]' />,
  },
  {
    label: 'Bạn bè',
    value: POST_MODE.friend,
    icon: <IconPeopleFill className='h-[18px] w-[18px]' />,
  },
  {
    label: 'Riêng tư',
    value: POST_MODE.private,
    icon: <IconLock className='h-[18px] w-[18px]' />,
  },
];

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req } = context;
  const { headers } = req;
  const device = detectDeviceByUserAgent(headers['user-agent']);

  return {
    props: {
      device,
    },
  };
};

export const CommunityPostPageContext: Context<Omit<Props, 'device'>> = createContext({});

interface Props {
  device?: 'mobile' | 'desktop';
  pageData?: null;
}

const CommunityPostPage: NextPage = (props: Props) => {
  const { device, ...restProps } = props;
  const title = `Cộng đồng - Mạng xã hội | ${DEFAULT_TITLE}`;
  const description = DEFAULT_DESCRIPTION;
  const ogUrl = `${MAIN_DOMAIN}/${SITE_MAP.SOCIAL_NETWORK.INDEX}/${SITE_MAP.SOCIAL_NETWORK.COMMUNITY_POST}`;
  const ogImage = DEFAULT_OG_IMAGE;

  return (
    <Fragment>
      <Head>
        <meta
          name='viewport'
          content='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
        />
        <meta name='description' content={description} />
        <meta name='og:title' content={title} />
        <meta name='og:description' content={description} />
        <meta name='og:url' content={ogUrl} />
        <meta name='og:image' content={ogImage} />
        <title>{title}</title>
      </Head>
      <CommunityPostPageContext.Provider value={restProps}>
        {isEqual(device, 'mobile') ? (
          <MobileCommunityPost />
        ) : isEqual(device, 'desktop') ? (
          <CommunityPost />
        ) : null}
      </CommunityPostPageContext.Provider>
    </Fragment>
  );
};

export default CommunityPostPage;
